import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SelectOption } from '@/features/editMode/types/selectOption';
import { GetSelectedPlaceDetailsPayload } from './types/GetSelectedPlaceDetailsPayload';
import { UpdateSelectedPlaceDetailsPayload } from './types/UpdateSelectedPlaceDetailsPayload';
import { initialGooglePlacesApiState } from './constants';

const googlePlacesApiSlice = createSlice({
  name: 'googlePlacesApi',
  initialState: initialGooglePlacesApiState,
  reducers: {
    updateSuggestedPlacesList: (state, { payload }: PayloadAction<SelectOption[]>) => {
      state.suggestedPlacesList = payload;
    },
    updateSelectedPlaceDetails: (
      state,
      { payload: { data, uniqPrefix } }: PayloadAction<UpdateSelectedPlaceDetailsPayload>,
    ) => {
      uniqPrefix ? (state.selectedPlaceDetails = { [uniqPrefix]: data }) : (state.selectedPlaceDetails = data);
    },
    setSuggestedPlacesListLoadingStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.statuses.isSuggestedPlacesListLoading = payload;
    },
    getSuggestedPlacesList: (_, _action: PayloadAction<string>) => {},
    getSelectedPlaceDetails: (_, _action: PayloadAction<GetSelectedPlaceDetailsPayload>) => {},
    resetGooglePlacesState: () => ({
      ...initialGooglePlacesApiState,
    }),
  },
  selectors: {
    selectSuggestedPlacesList: (state) => state.suggestedPlacesList,
    selectSelectedPlaceDetails: (state) => state.selectedPlaceDetails,
    selectSuggestedPlacesListIsLoading: (state) => state.statuses.isSuggestedPlacesListLoading,
  },
});

export const {
  resetGooglePlacesState,
  setSuggestedPlacesListLoadingStatus,
  updateSuggestedPlacesList,
  getSuggestedPlacesList,
  getSelectedPlaceDetails,
  updateSelectedPlaceDetails,
} = googlePlacesApiSlice.actions;

export const { selectSuggestedPlacesList, selectSuggestedPlacesListIsLoading, selectSelectedPlaceDetails } =
  googlePlacesApiSlice.selectors;

export const googlePlacesApiReducer = googlePlacesApiSlice.reducer;
export const googlePlacesApiReducerPath = googlePlacesApiSlice.reducerPath;
